import { useCurrentUser } from 'client/components/auth/AuthModule';
import { Note } from 'client/components/schema/note/detail/Note';
import { TaskInfoLine } from 'client/components/schema/note/detail/TaskInfoLine';
import { UserInfoLine } from 'client/components/schema/note/detail/UserInfoLine';
import { ITaskNote } from 'client/routes/procedure/single/notes/mapProcedureNotes';
import * as React from 'react';

export interface NoteItemProps {
  note: ITaskNote;
}
/**
 * La singola nota dell'utente relativa ad una attività
 */
export function NoteItem(props: NoteItemProps) {
  const { note } = props;

  const currentUser = useCurrentUser();

  const isSameUser =
    currentUser?.utenteLoggato?.codiceFiscale === note.userFiscalNumber;

  return (
    <Note
      isCurrentUser={isSameUser}
      name={note.userName}
      beforeContent={<UserInfoLine name={note.userName!} />}
      afterContent={
        <TaskInfoLine
          date={note.outcomeDate!}
          action={note.outcome!}
          task={note.taskName!}
        />
      }
    >
      {note.note}
    </Note>
  );
}
